import { ActionButton } from '@mentimeter/slides-presentation-ui/controls/action-button';
import type { SlideSpecificActionI18nKey } from '@mentimeter/i18n-presenting';
import type { DefaultValidKeyCodesT } from '@mentimeter/hotkeys';
import type { RegisteredHotkeysT } from '@mentimeter/question-modules-types';
import type { IconT } from '@mentimeter/ragnar-visuals';
import { Hotkey } from '../../../shared/components/Hotkey';

interface SlideControlsButtonProps {
  id: string;
  displayControl?: boolean;
  enableHotkeys?: boolean;
  success: boolean;
  successText: string;
  slideSpecificActionsTranslationKey: SlideSpecificActionI18nKey;
  hotkeys: Array<RegisteredHotkeysT>;
  conflictingKeys?: Array<DefaultValidKeyCodesT>;
  onHotkey?: (arg0: DefaultValidKeyCodesT) => void;
  onClick: () => void;
  isLoading?: boolean;
  icon?: (props: IconT) => React.JSX.Element;
}

export const SlideControlsButton = ({
  displayControl = true,
  hotkeys = [],
  conflictingKeys = [],
  onHotkey,
  onClick,
  id,
  isLoading,
  icon,
  enableHotkeys = true,
  success,
  successText,
  slideSpecificActionsTranslationKey,
}: SlideControlsButtonProps) => {
  return (
    <>
      {onHotkey &&
        hotkeys.map((key) => (
          <Hotkey
            key={key}
            keyCode={key}
            preventDefault
            conflictingKeys={conflictingKeys}
            action={onHotkey}
          />
        ))}
      {displayControl && (
        <ActionButton
          onClick={onClick}
          id={id}
          isLoading={!!isLoading}
          icon={icon}
          hotkey={hotkeys[0]}
          enableHotkeys={enableHotkeys}
          success={success}
          successText={successText}
          slideSpecificActionsTranslationKey={
            slideSpecificActionsTranslationKey
          }
        />
      )}
    </>
  );
};
